import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchCart, verifyPayPalPayment } from "../slices/cartSlice";
import { loginModelOpen, SuccessMessage } from "../common/Helper";
import { HomeSvg } from "../../svg/Index";
import { useAuth } from "../hooks/IsAuth";

const OrderSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { isLoggedIn } = useAuth()

    const [searchParams] = useSearchParams();

    const [verifying, setVerifying] = useState(true);
    const [orderDetails, setOrderDetails] = useState(null);
    const [error, setError] = useState(null);
    const [hasProcessed, setHasProcessed] = useState(false);

    const state = location.state || {};

    useEffect(() => {
        const verifyPayment = async () => {
            if (hasProcessed) return;

            const urlParams = new URLSearchParams(window.location.search);
            const sessionId = urlParams.get('session_id');
            const token = urlParams.get('token');

            if (!sessionId && !token && !state.paymentMethod) {
                setError("Invalid payment status");
                setVerifying(false);
                setHasProcessed(true);
                return;
            }

            setVerifying(true);

            try {
                if (token) {
                    const result = await dispatch(verifyPayPalPayment(token)).unwrap();

                    if (result.success) {
                        SuccessMessage("Payment successful!");
                        setOrderDetails({
                            orderId: result.data?.order_id,
                            orderNumber: result.data?.order_number,
                            total: result.data?.total || state.total,
                            estimatedDelivery: result.data?.estimated_delivery,
                            paymentMethod: "paypal",
                            paymentId: token
                        });
                        dispatch(fetchCart());
                    } else {
                        setError(result?.message || "Payment verification failed");
                    }
                }
                else if (state.paymentMethod) {
                    setOrderDetails(state);
                }

                if (orderDetails || (sessionId || token || state.paymentMethod)) {

                }

            } catch (error) {
                setError("Payment verification failed. Please contact support.");
            } finally {
                setVerifying(false);
                setHasProcessed(true);
            }
        };

        verifyPayment();
    }, [dispatch, searchParams, hasProcessed]);

    const handleOpenLoginWithForgotPassword = () => {
        loginModelOpen()
    };


    if (verifying) {
        return (
            <div className="comman-shadow pt-4">

                <div className='breadcrumb-sec-main py-5'>
                    <div className="container">
                        <nav aria-label="breadcrumb text-center">
                            <h3 className='fw-semibold  text-center'>Order Confirmation</h3>
                            <ol className="breadcrumb justify-content-center align-items-center">
                                <li className="breadcrumb-item active">
                                    <Link className="font--15" to="/" data-discover="true">
                                        <span className="me-1">
                                            <HomeSvg />
                                        </span>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item font--15">
                                    Order Confirmation
                                </li>
                            </ol>
                        </nav>

                    </div>
                </div>
                <section className="checkout-section">
                    <div className="container">
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Verifying your payment...</p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    if (!error) {
        return (
            <div className="comman-shadow pt-4">
                <div className='breadcrumb-sec-main py-5'>
                    <div className="container">
                        <nav aria-label="breadcrumb text-center">
                            <h3 className='fw-semibold  text-center'>Payment Failed</h3>
                            <ol className="breadcrumb justify-content-center align-items-center">
                                <li className="breadcrumb-item active">
                                    <Link className="font--15" to="/" data-discover="true">
                                        <span className="me-1">
                                            <HomeSvg />
                                        </span>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item font--15">
                                    Payment Failed
                                </li>
                            </ol>
                        </nav>

                    </div>
                </div>
                <section className="checkout-section">
                    <div className="container">
                        <div className="payment-status-card-container"
                        >
                            <div className="payment-status-card">
                                <div className="payment-status-card-content mt-3">
                                    <img src="/image/payment-failed.png" alt="" />
                                </div>
                                <div className="payment-status-card-content mt-3">
                                    <h4>Payment Failed</h4>
                                    <p>{error}</p>
                                    <button className="btn small failed-btn mt-3" onClick={() => navigate("/checkout")}>
                                        Return to Checkout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    if (orderDetails) {
        return (
            <div className="comman-shadow pt-4">
                <div className='breadcrumb-sec-main py-5'>
                    <div className="container">
                        <nav aria-label="breadcrumb text-center">
                            <h3 className='fw-semibold  text-center'>Order Status</h3>
                            <ol className="breadcrumb justify-content-center align-items-center">
                                <li className="breadcrumb-item active">
                                    <Link className="font--15" to="/" data-discover="true">
                                        <span className="me-1">
                                            <HomeSvg />
                                        </span>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item font--15">
                                    Order Status
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <section className="checkout-section">
                    <div className="container">
                        <div className="payment-status-card-container"
                        >
                            <div className="payment-status-card success">
                                <div className="spinner-border text-warning" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-3">Processing your order...</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className="comman-shadow pt-4">
            <div className='breadcrumb-sec-main py-5'>
                <div className="container">
                    <nav aria-label="breadcrumb text-center">
                        <h3 className='fw-semibold  text-center'>Order Confirmation</h3>
                        <ol className="breadcrumb justify-content-center align-items-center">
                            <li className="breadcrumb-item active">
                                <Link className="font--15" to="/" data-discover="true">
                                    <span className="me-1">
                                        <HomeSvg />
                                    </span>
                                    Home
                                </Link>
                            </li>
                            <li className="breadcrumb-item font--15">
                                Order Confirmation
                            </li>
                        </ol>
                    </nav>

                </div>
            </div>

            <section className="checkout-section">
                <div className="container">

                    <div className="payment-status-card-container">
                        <div className="payment-status-card success">
                            <div className="payment-status-card-content mt-3">
                                <img src="/image/payment-success.png" alt="" />
                            </div>
                            <div className="payment-status-card-content mt-3">

                                <h4 className="mb-3">Order Confirmed!</h4>
                                <p className="mb-0">
                                    Thank you for your purchase. Your order has been received and is being processed.
                                </p>


                                {isLoggedIn ? (
                                    <button
                                        className="btn small success-btn mt-4 text-white"
                                        onClick={() => navigate("/my-order")}
                                    >
                                        View My Orders
                                    </button>
                                ) : (
                                    <button
                                        className="btn small success-btn mt-4 text-white"
                                        onClick={handleOpenLoginWithForgotPassword}
                                    >
                                        Forgot password or Login to view your orders
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OrderSuccess;